import {
  getVariantProps
} from "./chunk-C6ESTM3N.mjs";

// src/internal/components/header/header-element.tsx
import Stack from "@mui/material/Stack";
import { jsx } from "react/jsx-runtime";
function HeaderElement(props) {
  const { variant, ...rest } = props;
  const variantProps = getVariantProps(variant);
  return /* @__PURE__ */ jsx(Stack, { ...variantProps, ...rest });
}
HeaderElement.displayName = "HeaderElement";
HeaderElement.id = "HeaderElement";

export {
  HeaderElement
};
